import Header from '../../components/Header/Header';
import WhatsappFloatingButton from '../../components/WhatsappFloatingButton/WhatsappFloatingButton';
import Footer from '../../components/Footer/Footer';
import { useParams, Link } from 'react-router-dom';
import { 
  ProductDetailWrapper, 
  ProductImage, 
  ProductTitle,
  MiniProductImage,
  SectionHeader,
  SectionContent,
  QuantityWrapper,
  AddButton,
  ProductDetailSpecificationGrid,
  SpecificationRow,
  MiniProductImageList,
  Select
} from './ProductDetail.styled';
import { useEffect, useState } from 'react';
import { PRODUCTS } from '../../utils/constants';
import useStore from '../../store/useStore';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import QuantityButtons from '../../components/QuantityButtons/QuantityButtons';
import ToastWrapper from '../../components/Toast/Toast';

const ProductDetail = () => {
  const { id } = useParams();
  const { setProducts, products } = useStore();

  const [product, setProduct] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [count, setCount] = useState(0);
  const [showToast, setShowToast] = useState(false);
  const [productVariant, setProductVariant] = useState(null);

  useEffect(() => {
    // Get the product data from the constants file
    setProduct(PRODUCTS.find(product => product.id === id) || null); 
    // Set the first image as the selected image
    setSelectedImage(PRODUCTS.find(product => product.id === id)?.variants[0]?.imagesList[0] || null);
    setProductVariant(PRODUCTS.find(product => product.id === id)?.variants[0] || null);
  }
  , [id]);

  const handleVariantChange = (evt) => {
    const selectedVariantName = evt.target.value;
    const selectedVariant = product?.variants.find(variant => variant.name === selectedVariantName);
    if(selectedVariant) {
      setProductVariant(selectedVariant);
      setSelectedImage(selectedVariant?.imagesList[0] || null);
    }
  }

  const onAddToQuotation = () => {
    const existingProduct = products?.[id] || product;

    const newVariants = existingProduct.variants.map(variant => {
      if (variant.name === productVariant.name) {
        return {
          ...variant,
          quantity: count
        };
      }
      return variant;
    });

    const updatedProduct = {
      ...existingProduct,
      variants: newVariants
    };

    setProducts({
      ...products, // <-- preserve all other products
      [id]: updatedProduct
    });

    setShowToast(true);
};

  return (
    <>
      <Header />
      <ProductDetailWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/products?category=${product?.category || 'all-products'}`}>Products</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item active>{product?.name}</Breadcrumb.Item>
        </Breadcrumb>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', paddingBottom: '2rem'}}>
          <ProductTitle>{product?.name}</ProductTitle>
        </div>
        {product && productVariant && 
          <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '0' }}>
            
            <div style={{display: 'flex', flexDirection: 'row', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center'}}>
              <MiniProductImageList>
                {productVariant?.imagesList.map((miniImage) => {
                  return (
                    <div>
                      <MiniProductImage onClick={() => setSelectedImage(miniImage)} src={miniImage} alt={product.name} />
                    </div>
                  )
                })}
              </MiniProductImageList>
              <div>
                <ProductImage src={selectedImage} alt={product.name} loading='lazy' />
              </div>
            </div>
            <div style={{display: 'flex', flexDirection: 'column', gap: '3rem'}}>
              <div>
                <SectionHeader>Deskripsi</SectionHeader>
                {product && productVariant && productVariant.description?.split('\n').map((line, index) => (
                  <SectionContent key={index}>{line}</SectionContent>
                ))}
              </div>
              <div>
                <SectionHeader>Spesifikasi</SectionHeader>
                <SectionContent>
                  <ProductDetailSpecificationGrid>
                    {productVariant?.volume && <SpecificationRow>Volume</SpecificationRow>}
                    {productVariant?.volume && <SpecificationRow>{productVariant?.volume}</SpecificationRow>}
                    {productVariant?.diameter && <SpecificationRow>Diameter</SpecificationRow>}
                    {productVariant?.diameter && <SpecificationRow>{productVariant?.diameter}</SpecificationRow>}
                    {productVariant?.height && <SpecificationRow>Tinggi</SpecificationRow>}
                    {productVariant?.height && <SpecificationRow>{productVariant?.height}</SpecificationRow>}
                    {/* {productVariant?.grammage && <SpecificationRow>Gramasi</SpecificationRow>}
                    {productVariant?.grammage && <SpecificationRow>{productVariant?.grammage}</SpecificationRow>} */}
                  </ProductDetailSpecificationGrid>
                </SectionContent>
              </div>
              <div>
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                  <p style={{margin: 0}}>Pilih varian</p>
                  {/* <Dropdown style={{width: '50%'}}>
                    <Dropdown.Toggle id="dropdown-variant" style={{width: '100%'}}>
                      {productVariant?.name}
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{width: '100%'}}>
                      {product?.variants?.map((variant) => {
                        return (
                          <Dropdown.Item 
                            key={variant.id} 
                            onClick={() => {
                              setProductVariant(variant);
                              setSelectedImage(variant?.imagesList[0]);
                            }}
                          >
                            {variant.name}
                          </Dropdown.Item>
                        )
                      })}
                    </Dropdown.Menu>
                  </Dropdown> */}
                  <Select onChange={handleVariantChange}>
                    {product?.variants?.map((variant) => {
                      return (
                        <option 
                          key={variant.name}
                          value={variant.name}
                        >
                          {variant.name}
                        </option>
                      )
                    })}
                  </Select>
                </div>
                
              </div>
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
                <QuantityWrapper>
                  <QuantityButtons quantity={count} onClickAdd={() => setCount(c => c + 1)} onClickSubtract={() => setCount(c => Math.max(0, c - 1))} />
                  <AddButton disabled={count === 0} onClick={onAddToQuotation}>Masukan Produk</AddButton>
                </QuantityWrapper>
              </div>
            </div>
          </div>
        }
      </ProductDetailWrapper>
      <ToastWrapper title="Produk ditambahkan" description={`${product?.name} ${productVariant?.name || ''} ditambahkan di dalam list quotation`} show={showToast} setShow={setShowToast} />
      <Footer />
      <WhatsappFloatingButton />
    </>
  );
}
export default ProductDetail;